export default class Range {
    constructor(min, max) {
        this.min = min;
        this.max = max;
    }
};


// WEBPACK FOOTER //
// ./src/classes/Range.js